import {Component, inject, PLATFORM_ID} from '@angular/core';
import {LpCtaComponent} from '../../common/lp/lp-cta/lp-cta.component';
import {HomeAnimationModel} from '../../../../model/home.model';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionResources} from '../../../../resources/session.resources';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {WINDOW} from '../../../config/module.di.tokens';

@Component({
  selector: 'app-home-top',
  imports: [
    LpCtaComponent
  ],
  templateUrl: './home-top.component.html',
  styleUrl: './home-top.component.scss'
})
export class HomeTopComponent {

  animationTerminated = false
  window = inject(WINDOW)
  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);
  router = inject(Router)
  route = inject(ActivatedRoute)
  sessionResources = inject(SessionResources)

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadAnimation()
    }
  }

  private loadAnimation() {
    const mainScrollElement = this.document.querySelector(".main-scroll") as HTMLElement;
    mainScrollElement.addEventListener('scroll', () => this.updateAnimationOnScroll(mainScrollElement));

    setTimeout(() => {
      const animVideoLeftElement = this.document.querySelector(".anim-left-heart") as HTMLMediaElement;
      const animVideoRightElement = this.document.querySelector(".anim-right-heart") as HTMLMediaElement;

      if (animVideoLeftElement) {
        animVideoLeftElement.muted = true;
        animVideoLeftElement.addEventListener('ended', () => animVideoLeftElement.load())
      }
      if (animVideoRightElement) {
        animVideoRightElement.muted = true;
        animVideoRightElement.addEventListener('ended', () => animVideoRightElement.load())
      }

    }, 1000)
  }

  goToEvents() {
    const homeEvents = this.document.getElementById('home-events')
    homeEvents.scrollIntoView({ behavior: 'smooth' });
  }

  private async updateAnimationOnScroll(mainScrollElement: HTMLElement) {

    if (!this.animationTerminated) {
      const blinkElement = this.document.querySelector(".anim-blinking") as HTMLElement;
      const animVideoLeftElement = this.document.querySelector(".anim-left-heart") as HTMLMediaElement;
      const animVideoRightElement = this.document.querySelector(".anim-right-heart") as HTMLMediaElement;

      const animationModel = this.buildAnimationModel()
      let inTranslation = this.translateWithRatio(mainScrollElement, "anim-left", animationModel.speedAnimeX, animationModel.speedAnimeY, animationModel.maxAnimeX, animationModel.maxAnimeY)
      inTranslation && this.translateWithRatio(mainScrollElement, "anim-right", -animationModel.speedAnimeX, animationModel.speedAnimeY, -animationModel.maxAnimeX, animationModel.maxAnimeY)

      if (blinkElement && animVideoLeftElement && animVideoRightElement) {
        blinkElement.style.display = inTranslation ? "none" : "block";
        animVideoLeftElement.style.display = inTranslation ? "none" : "block";
        animVideoRightElement.style.display = inTranslation ? "none" : "block";
        if (!inTranslation) {
          await animVideoLeftElement.play()
          await animVideoRightElement.play()
          this.animationTerminated = true
        }
        this.translateWithRatio(mainScrollElement, "anim-center", animationModel.speedAnimeCenterX, animationModel.speedAnimeCenterY, animationModel.maxAnimeCenterX, animationModel.maxAnimeCenterY)
      }
    }
  }

  private buildAnimationModel() {
    let animationModel = new HomeAnimationModel()

    if (this.window.innerWidth < 1300) {
      animationModel.speedAnimeX = 1.4
      animationModel.speedAnimeY = 1.8
      animationModel.maxAnimeY = 250
      animationModel.speedAnimeCenterY = 2
      animationModel.maxAnimeCenterY = 200
    }
    if (this.window.innerWidth < 1000) {
      animationModel.speedAnimeX = 0.5
      animationModel.speedAnimeY = 1.5
      animationModel.maxAnimeY = 200
      animationModel.speedAnimeCenterY = 1.5
      animationModel.maxAnimeCenterY = 140
    }
    if (this.window.innerWidth < 640) {
      animationModel.speedAnimeX = 0.75
    }
    if (this.window.innerWidth < 480) {
      animationModel.speedAnimeX = 0.4
      animationModel.speedAnimeY = 0.8
      animationModel.speedAnimeCenterY = 0
      animationModel.maxAnimeX = 100
      animationModel.maxAnimeY = 100
    }
    return animationModel
  }

  private translateWithRatio(
    mainScrollElement: HTMLElement,
    className: string,
    speedX: number,
    speedY: number,
    maxTranslationX: number,
    maxTranslationY: number) {

    let inTranslation = false
    const element = this.document.querySelector(`.${className}`) as HTMLElement;
    if (element) {
      const scrollPosition = mainScrollElement.scrollTop;
      const elementPosition = element.getBoundingClientRect().top + scrollPosition;

      if (elementPosition < scrollPosition + this.window.innerHeight && elementPosition + element.offsetHeight > scrollPosition) {
        const translationX = scrollPosition * speedX ;
        const translationY = Math.min(scrollPosition * speedY, this.window.innerHeight);

        if (((maxTranslationX >= 0 && translationX <= maxTranslationX) || (maxTranslationX < 0 && translationX > maxTranslationX))
          && ((maxTranslationY >= 0 && translationY <= maxTranslationY) || (maxTranslationY < 0 && translationY > maxTranslationY))) {
          element.style.transform = `translate(${translationX}px, ${translationY}px)`;
          inTranslation = true
        }
      } else {
        element.style.transform = `translate(0%, 0%) translateY(0px)`;
      }
    }
    return inTranslation;
  }
}
